// extracted by mini-css-extract-plugin
module.exports =  {"signUpContainer":"SignUpComponent_signUpContainer__ETp6I","signInLinkContainer":"SignUpComponent_signInLinkContainer__O7V2B"};